/**
 * Google Maps API Configuration
 * 
 * To use Google Maps, you need to:
 * 1. Get a Google Maps API key from: https://console.cloud.google.com/google/maps-apis
 * 2. Enable the following APIs:
 *    - Maps JavaScript API
 *    - Directions API
 *    - Geocoding API
 * 3. Add your API key to environment variable: REACT_APP_GOOGLE_MAPS_API_KEY
 *    Or set it directly in this file (not recommended for production)
 */

// Get API key from environment variable or use placeholder
export const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || '';

// Default map options
export const DEFAULT_MAP_OPTIONS = {
  zoom: 13,
  center: { lat: 50.8769, lng: 6.8875 }, // Default to Köln/Hürth
  mapTypeControl: false,
  streetViewControl: false,
  fullscreenControl: true,
} as google.maps.MapOptions;

